import type { PaymentEventDef } from '@rb/shared/master-data/types';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { formatKst, paymentEventStatus, type PaymentEventStatus } from './payment-event.model';

const STATUS_LABEL: Record<PaymentEventStatus, string> = {
  scheduled: '예정',
  running: '진행중',
  grace: '유예중',
  ended: '종료',
};

interface Props {
  row: PaymentEventDef;
  saving: boolean;
  onActivate: () => void;
  onEdit: () => void;
  onClone: () => void;
  onDelete: () => void;
}

/** 목록 한 행 — 상태 배지 + 활성 라디오 + 편집/복제/삭제. */
export function PaymentEventRow({ row, saving, onActivate, onEdit, onClone, onDelete }: Props) {
  const status = paymentEventStatus(row, Date.now());
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-md border border-border px-3 py-2 text-sm">
      <input
        type="radio"
        name="payment-event-active"
        aria-label={`이벤트 ${row.id} 활성화`}
        checked={row.active}
        disabled={saving}
        onChange={onActivate}
      />
      <span className="font-mono">#{row.id}</span>
      <Badge variant={status === 'running' ? 'default' : 'secondary'}>{STATUS_LABEL[status]}</Badge>
      <span className="text-muted-foreground">
        {formatKst(row.start_at)} ~ {formatKst(row.end_at)}
      </span>
      <span className="text-muted-foreground">티어 {row.tiers.length}</span>
      <div className="ml-auto flex gap-1">
        <Button type="button" size="sm" variant="outline" onClick={onEdit}>
          편집
        </Button>
        <Button type="button" size="sm" variant="outline" onClick={onClone}>
          복제
        </Button>
        <Button type="button" size="sm" variant="destructive" disabled={saving} onClick={onDelete}>
          삭제
        </Button>
      </div>
    </div>
  );
}
